import { ReturnMedicineDTO } from "../../dtos/batch";
import axios from "../../utils/axiosConfig";
 
axios.defaults.withCredentials = true;

const getSales = async (pharmacy_id: any) => {
  const { data } = await axios.get( `/api/pharmacy/sales/get?pharmacy_id=${pharmacy_id}`);
  return data;
};
const AddSales = async (pharmacy_id: string, salesPayload: any) => {
  try {
    const { data } = await axios.post( `/api/pharmacy/sales/add?pharmacy_id=${pharmacy_id}`, salesPayload);
    return data;
  } catch (error) {
    throw error; // Handle errors appropriately
  }
};
const AddReturnSales = async (returnSalesPayload: ReturnMedicineDTO) => {
  try {
    const { data } = await axios.post( `api/pharmacy/sales/return`, returnSalesPayload);
    return data;
  } catch (error) {
    throw error; // Handle errors appropriately
  }
};
const EditSales = async (pharmacy_id: string, salesPayload: any) => {
  try {
    const { data } = await axios.put( `/api/pharmacy/sales/update?pharmacy_id=${pharmacy_id}`, salesPayload);
    return data;
  } catch (error) {
    throw error; // Handle errors appropriately
  }
};

const getMedicineBatchList = async (medicine_id: any , pharmacy_id: any) => {
  const { data } = await axios.get(`/api/pharmacy/batch/get_product_detail?medicine_id=${medicine_id}&pharmacy_id=${pharmacy_id}`);    
  return data;
};

const SalesService = {
    getSales,
    AddSales,
    EditSales,
    AddReturnSales,
    getMedicineBatchList
};

export default SalesService;
